import axios from 'axios';
import url from '@/config.js';
const service = axios.create({
    baseURL: url.serverURL,
    timeout: 50000
});
//请求拦截器
service.interceptors.request.use(
    config => {
        if (config.url.indexOf("rrb-web")  == 0) {
            config["headers"].common["site_id"] = 3;
            config.baseURL = url.newsURL;
        };
        if (config.url.indexOf("oasis")  == 0) {
            config.baseURL = url.oasisURL;
        };
        if (config.url.indexOf("hqconsole")  == 0) {
            config.baseURL = url.rrbURL;
        };
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);
//响应拦截器
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);
export default service;